
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import zh from './zh'//中文
import ja from './jp'  //日文
import en from './en'  //英文
Vue.use(VueI18n)
 
const messages = {
    zh: {
        language: 'zh',
        ...zh,
        ...zhLocale
    },
    ja: {
        language: 'ja',
        ...ja,
        ...jaLocale
    },
    en: {
        language: 'en',
        ...en,
        ...enLocale
    }
}
const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'ja', // 语言类型存储到localstorage里
    messages
})
// 导出messages 给切换语言的时候用
export { i18n, messages }